const url_regex = new RegExp(`^https?://[^/]+/\\w+/${"p"}/([^/]+)/?$`);

export const variant_to_product = {
    url_key: { value: (v) => v.url?.replace(url_regex, '$1') },
    sku: {
        value: (v) => ({
            value: v.variantID
        })
    },
    name: {
        value: (v) => ({
            value: v.label
        })
    },
    type_id: { value: (v) => (Number.isNaN(Number.parseInt(v.variantID, 10)) ? 'configurable' : 'simple') },
    thumbnail: {
        emit: (v) => v.imageLink,
        value: (v) => ({
            value: v.imageLink?.replace(/.*?\/media\/catalog\/product(.*)$/, '$1')
        })
    },
    price: { value: (v) => ({ value: v.variantInfo?.originalPrice }) },
    quantity_and_stock_status: {
        value: (v) => {
            const qty = v.variantInfo?.stock ?? 0;
            return { value: { is_in_stock: qty > 0, qty } };
        }
    },
    final_price: { value: (v) => v.price },
    pim_brand: {
        emit: (v) => v.variantInfo?.brand_name,
        value: (v) => ({
            name: v.variantInfo?.brand_name,
            value: v.variantInfo?.brand_value
        })
    },
    kw_sustainable: {
        value: (v) => ({
            value: v.variantInfo?.kw_sustainable ? '1' : '0'
        })
    },
    kw_price_request: {
        value: (v) => ({
            value: v.variantInfo?.price_request ? '1' : '0'
        })
    },
    is_bestseller: { value: (v) => (v.variantInfo?.is_bestseller ? '1' : '0') },
    is_vegan: { value: (v) => (v.variantInfo?.is_vegan ? '1' : '0') },
    category_ids: {
        value: (v) => ({
            value: v.variantInfo?.category_ids
        })
    },
    kw_main_color: {
        emit: (v) => v.variantInfo?.color_id,
        value: (v) => ({
            value: v.variantInfo?.color_id,
            name: v.variantInfo?.color ?? v.variantInfo?.color_id
        })
    },
    kw_product_type: {
        emit: (v) => v.variantInfo?.product_type_id,
        value: (v) => ({
            value: v.variantInfo?.product_type_id,
            name: v.variantInfo?.product_type ?? v.variantInfo?.product_type_id
        })
    },
    kw_sizeindex: {
        emit: (v) => v.variantInfo?.sizeindex_id,
        value: (v) => ({
            value: v.variantInfo?.sizeindex_id,
            name: v.variantInfo?.sizeindex ?? v.variantInfo?.sizeindex_id
        })
    },
    kw_rolls_num: {
        emit: (v) => v.variantInfo?.rolls_id,
        value: (v) => ({
            value: v.variantInfo?.rolls_id,
            name: v.variantInfo?.rolls ?? v.variantInfo?.rolls_id
        })
    },
    kw_outdoor_diverse: {
        emit: (v) => v.variantInfo?.exterior_id,
        value: (v) => ({
            value: v.variantInfo?.exterior_id?.join(','),
            name: (v.variantInfo?.exterior ?? v.variantInfo?.exterior_id)?.join(',')
        })
    },
    kw_interior_diverses: {
        emit: (v) => v.variantInfo?.interior_id,
        value: (v) => ({
            value: v.variantInfo?.interior_id?.join(','),
            name: (v.variantInfo?.interior ?? v.variantInfo?.interior_id)?.join(',')
        })
    },
    kw_serie: {
        emit: (v) => v.variantInfo?.serie_id,
        value: (v) => ({
            value: v.variantInfo?.serie_id,
            name: v.variantInfo?.serie ?? v.variantInfo?.serie_id
        })
    },
    kw_material_type: {
        emit: (v) => v.variantInfo?.material_type_id,
        value: (v) => ({
            value: v.variantInfo?.material_type_id,
            name: v.variantInfo?.material_type ?? v.variantInfo?.material_type_id
        })
    },
    kw_material_new: {
        emit: (v) => v.variantInfo?.material_id,
        value: (v) => ({
            value: v.variantInfo?.material_id,
            name: v.variantInfo?.material ?? v.variantInfo?.material_id
        })
    }
};
